/**
 * Decodifica o payload de um JWT de forma segura.
 *
 * JWTs usam base64url (`-` e `_`), que o `atob` nativo não aceita — decodificar
 * com `atob` puro falha de forma intermitente dependendo do conteúdo do payload.
 * Retorna `null` para token ausente/malformado em vez de lançar.
 */
export function decodeJwtPayload<T = Record<string, any>>(token: string | null | undefined): T | null {
  if (!token) return null;
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const json = decodeURIComponent(
      atob(padded)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );
    return JSON.parse(json) as T;
  } catch {
    return null;
  }
}
